// extracted by mini-css-extract-plugin
export default {"container":"CircleIcon_container__PP2yc","Icon":"CircleIcon_Icon__7zkYf"};